import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bettingType',
})
export class BettingTypePipe implements PipeTransform {
  transform(value: any, country?: string): any {
    if (country === 'United States of America' || country === 'Canada') {
      switch (value) {
        case 'Win':
        case 'win':
          return 'RACES.WIN';
        case 'show':
          return 'Place(3)';
        case 'win_show':
          return 'Win/Place(3)';
        case 'place':
          return 'Place(2)';
        case 'place_show':
          return 'Place(2)/Place(3)';
        case 'win_place_show':
          return 'Win/Place(2)/Place(3)';
        case 'win_place':
          return 'Win/Place(2)';
        case 'Quinella':
        case 'quinella':
          return 'RACES.QUINELLA';
        case 'Swinger':
        case 'swinger':
          return 'RACES.SWINGER';
        case 'Quinella Swinger':
        case 'quinella_swinger':
          return 'RACES.QUINELLA_SWINGER';
        case 'Trifecta':
        case 'trifecta':
          return 'RACES.TRIFECTA';
        case 'pmu_super_4':
          return 'Super 4';
        case 'pmu_tierce':
        case 'Tiercé':
          return 'RACES.TIERCE';
        case 'pmu_tierce_standard':
        case 'Tiercé Standard':
          return 'RACES.TIERCE_STANDARD';
        case 'pmu_quarte_plus':
        case 'Quarté+':
          return 'RACES.QUARTE';
        case 'pmu_quinte_plus':
        case 'Pmu_quinte_plus':
        case 'Quinte+':
        case 'Quinté+':
          return 'RACES.QUINTE';
        case 'pmu_quarte_plus_standard':
        case 'Quarté Standard':
          return 'RACES.QUARTE_STANDARD';
        case 'pmu_quinte_plus_standard':
        case 'Pmu_quinte_plus_standard':
        case 'Quinte Standard':
        case 'Quinté Standard':
          return 'RACES.QUINTE_STANDARD';
        default:
          return value;
      }
    } else {
      switch (value) {
        case 'Win':
        case 'win':
          return 'RACES.WIN';
        case 'Show':
        case 'show':
          return 'RACES.PLACE';
        case 'Win Show':
        case 'win_show':
        case 'Win_show':
          return 'RACES.WIN_PLACE';
        case 'Quinella':
        case 'quinella':
          return 'RACES.QUINELLA';
        case 'Swinger':
        case 'swinger':
          return 'RACES.SWINGER';
        case 'Quinella Swinger':
        case 'quinella_swinger':
          return 'RACES.QUINELLA_SWINGER';
        case 'Trifecta':
        case 'trifecta':
          return 'RACES.TRIFECTA';
        case 'pmu_tierce':
        case 'Tiercé':
          return 'RACES.TIERCE';
        case 'pmu_super_4':
          return 'Super 4';
        case 'pmu_tierce_standard':
        case 'Tiercé Standard':
          return 'RACES.TIERCE_STANDARD';
        case 'pmu_quarte_plus':
        case 'Quarté+':
          return 'RACES.QUARTE';
        case 'pmu_quinte_plus':
        case 'Quinte+':
        case 'Quinté+':
          return 'RACES.QUINTE';
        case 'pmu_quinte_plus_standard':
        case 'Pmu_quinte_plus_standard':
        case 'Quinte Standard':
        case 'Quinté Standard':
          return 'RACES.QUINTE_STANDARD';
        case 'pmu_quarte_plus_standard':
        case 'Quarté Standard':
          return 'RACES.QUARTE_STANDARD';
        default:
          return value;
      }
    }
  }
}
